import { ElementType } from "react";

export interface ReactUIConfig {
  linkComponent?: ElementType;
  imageComponent?: ElementType;
}

let config: ReactUIConfig = {};

/** @deprecated Wrap the app in `ReactUIProvider` instead. */
export const setConfig = (value: ReactUIConfig) => {
  config = value;
};

export const getLinkComponent = () => {
  return config.linkComponent || "a";
};

export const getImageComponent = () => {
  return config.imageComponent || "img";
};
